/**
 * @description 学员维度
 * @Date 2023/11/10
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

const _getValue = (type, key) => {
  const values = {
    userIdentityType: {
      2: '否',
      1: '是',
    },
    accountState: {
      0: '禁用',
      1: '激活'
    },
    jobState: {
      0: '离职',
      1: '在职'
    },
    type: {
      0: '课程',
      1: '考试',
      2: '作业',
      3: '直播',
      4: '路径',
      5: '班级'
    },
    pass: {
      0: '未通过',
      1: '通过'
    }
  }
  return values[type][key] || ''
}

const _getTypeValue = (type, key) => {
  const values = {
    0: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    },
    1: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    },
    2: {
      0: '草稿',
      1: '已发布',
      2: '已取消',
      3: '已结束'
    },
    3: {
      1: '草稿',
      2: '预告中',
      3: '直播中',
      4: '已结束'
    },
    4: {
      1: '草稿',
      2: '已发布',
      3: '已结束'
    },
    5: {
      0: '草稿',
      1: '已发布',
      2: '已关闭',
    }
  }
  return values[type][key] || ''
}

class DimStudentReport extends WizContainer {
  componentName = "DimStudentReport";

  constructor(props) {
    super(props);
    this.state = {
      type: null
    }
  }

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        userIdentityType: _getValue('userIdentityType', val.userIdentityType),
        accountState: _getValue('accountState', val.accountState),
        jobState: _getValue('jobState',val.jobState),
        type: _getValue('type',val.type),
        pass: _getValue('pass', val.pass),
        bizState: _getTypeValue(val.type, val.bizState)
      }))

      const title = '学员维度报表信息'

      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true

    } else {
      wizNotice.error(msg)
      return false;
    }

  }

  
  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _templateConfig = templateConfig(this)
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this.handleFile,
        list: this._handleCMD,
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(DimStudentReport);
